/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cancel_SubscriptionInputs */

const en_cancel_subscription = /** @type {(inputs: Cancel_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel Subscription`)
};

const fr_cancel_subscription = /** @type {(inputs: Cancel_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annuler l'abonnement`)
};

const de_cancel_subscription = /** @type {(inputs: Cancel_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonnement kündigen`)
};

const it_cancel_subscription = /** @type {(inputs: Cancel_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annulla abbonamento`)
};

const ru_cancel_subscription = /** @type {(inputs: Cancel_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отменить подписку`)
};

const es_cancel_subscription = /** @type {(inputs: Cancel_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelar suscripción`)
};

const zh_cn2_cancel_subscription = /** @type {(inputs: Cancel_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`取消订阅`)
};

const ja_cancel_subscription = /** @type {(inputs: Cancel_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サブスクリプションをキャンセルする`)
};

const hi_cancel_subscription = /** @type {(inputs: Cancel_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सदस्यता रद्द करें`)
};

const pt_pt2_cancel_subscription = /** @type {(inputs: Cancel_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelar assinatura`)
};

/**
* | output |
* | --- |
* | "Cancel Subscription" |
*
* @param {Cancel_SubscriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const cancel_subscription = /** @type {((inputs?: Cancel_SubscriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cancel_SubscriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_cancel_subscription(inputs)
	if (locale === "de") return de_cancel_subscription(inputs)
	if (locale === "it") return it_cancel_subscription(inputs)
	if (locale === "ru") return ru_cancel_subscription(inputs)
	if (locale === "es") return es_cancel_subscription(inputs)
	if (locale === "zh-CN") return zh_cn2_cancel_subscription(inputs)
	if (locale === "ja") return ja_cancel_subscription(inputs)
	if (locale === "hi") return hi_cancel_subscription(inputs)
	if (locale === "pt-PT") return pt_pt2_cancel_subscription(inputs)
	return en_cancel_subscription(inputs)
});